<template>
  <FirstDraftButton
    :disabled="isDisabled"
    class="pa-0"
    variant="plain"
    @click="onClick"
    height="24"
  >
    <span class="text-button-2">
      Iterate with First Draft
    </span>
  </FirstDraftButton>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useFirstDraft } from '@/stores/document/firstDraft';
import { useTracking } from '@/stores/tracking/tracking';
import FirstDraftButton from '@ui/components/firstDraft/FirstDraftButton.vue';

export default {
  name: 'FirstDraftButtonForSubmenu',
  components: { FirstDraftButton },

  computed: {
    ...mapState(useFirstDraft, { isDisabled: 'disabled' }),
  },

  methods: {
    ...mapActions(useFirstDraft, ['setModalVisible', 'reset', 'generateNewContent']),

    onClick() {
      useTracking().trackName({ name: 'Clicked: Iterate with First Draft' });

      this.reset();
      this.setModalVisible(true);
      this.generateNewContent();
    },
  },
};
</script>
